<!-- <button nz-button nz-dropdown nzTrigger="click" [disabled]="disabled" [nzDropdownMenu]="dynOpt">
  {{ 'word.dyn_content' | translate }}
  <span nz-icon nzType="down"></span>
</button> -->

<img
  class="w-[20px] h-[20px] cursor-pointer"
  src="/assets/v4/icon-code.svg"
  alt="Add a short code"
  title="Add a short code"
  nz-dropdown
  nzTrigger="click"
  [nzDropdownMenu]="dynOpt"
/>

<!-- <div
  class="dyn-picker-placeholder selector d-flex flex-row align-items-center"
  nz-dropdown
  nzTrigger="click"
  [nzDisabled]="disabled"
  [nzDropdownMenu]="dynOpt"
  [nzBackdrop]="false">
  <div class="selection placeholder">{{ "word.dyn_content" | translate }}</div>
  <i nz-icon nzType="down" class="arrow"></i>
</div> -->
<nz-dropdown-menu #dynOpt="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    <li nz-menu-item *ngFor="let content of listOfDynContentOption"
        (click)="onSelect.emit(content.value)">
      {{ content.label }}
    </li>
  </ul>
</nz-dropdown-menu>
<!-- <div class="dyn-content-picker">
</div> -->
